import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/base/InstagramPost.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/sections/ArticleDetailHeader.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/sections/ArticleOrEventRecommendation.tsx")